import * as React from "react";
import useNotification from "./useNotification";

function Notification() {

	const { notification, removeNotification } = useNotification();
	const liveChatContainer = document.querySelector("#chat-widget-container");

	if (!notification) {
		return null;
	}

	function hideLiveChat() {
		if (liveChatContainer) {
			liveChatContainer.setAttribute("hidden", "true");
		}
	}

	function showLiveChat() {
		if (liveChatContainer) {
			liveChatContainer.removeAttribute("hidden");
		}
	}

	function handleCloseNotification() {
		removeNotification();
		showLiveChat();
	}

	React.useEffect(() => {
		hideLiveChat();
		setTimeout(() => {
			handleCloseNotification();
		}, 5000);
	}, []);

	return (
		<div className="c-alert-message--toast-container" data-test="wishlist-notification">
			<div className={`c-alert-message c-alert-message--${notification.type}`}>
				<button type="button" className="c-alert-message__close" onClick={handleCloseNotification}>
					<svg viewBox="0 0 24 24" className="c-alert-message__close-icon" width={24} height={24}>
						<path d="M18.984 6.422l-5.578 5.578 5.578 5.578-1.406 1.406-5.578-5.578-5.578 5.578-1.406-1.406 5.578-5.578-5.578-5.578 1.406-1.406 5.578 5.578 5.578-5.578z" fill="currentColor"></path>
					</svg>
					<span className="u-visuallyhidden">Close notification</span>
				</button>
				{notification.headline}
				<span>{notification.message}</span>
			</div>
		</div>
	);
}

export default Notification;
